import _ from 'lodash';
import Api from 'tm3-core/api';

let inProgress = {};
let cache = {};

let lazy = function (url: string, method = 'get', data?: any) {
  const key = url + method;
  if (_.isEmpty(cache[key])) {
    if (inProgress[key]) {
      return inProgress[key];
    }
    inProgress[key] = Api[method](url, data)
      .catch(() => {
        return (inProgress[key] = undefined);
      })
      .then((res) => {
        if (res && res.body && res.body.results) {
          cache[key] = res.body.results;
          inProgress[key] = undefined;
          res;
        }
        return res;
      });
    return inProgress[key];
  } else {
    return new Promise((resolve, reject) => {
      return resolve({
        body: {
          results: cache[key]
        }
      });
    });
  }
};

lazy.item = function (url, method = 'get', data) {
  const key = url + method;

  if (_.isEmpty(cache[key])) {
    if (inProgress[key]) {
      return inProgress[key];
    }
    inProgress[key] = Api[method](url, data)
      .then((res) => {
        cache[key] = res.body.result;
        inProgress[key] = undefined;
        return res;
      })
      .catch(() => {
        return (inProgress[key] = undefined);
      });
    return inProgress[key];
  } else {
    return new Promise((resolve, reject) => {
      return resolve({
        body: {
          result: cache[key]
        }
      });
    });
  }
};

lazy.clear = function clear(url, method = 'get') {
  if (url) {
    const key = url + method;
    delete cache[key];
    return delete inProgress[key];
  } else {
    cache = {};
    return (inProgress = {});
  }
};

lazy.update = function update(url, data, method = 'get') {
  const key = url + method;
  return (cache[key] = data);
};

export default lazy;

export const { item, clear, update } = lazy;
